import {PlatformCode} from '@dms/api/shared';

import type {VehicleTipCarsPlatformAdvertisingAttribute} from './VehicleTipCarsPlatformAdvertisingAttribute';

export type VehicleTipCarsPlatformAdvertisingSettings = {
  platformCode: PlatformCode;
  enabled: boolean;
  attributes: Array<VehicleTipCarsPlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleTipCarsPlatformAdvertisingSettings {
  export enum platformCode {
    TIPCARS = 'tipcars',
  }
}
